import React, { useState, useRef, useEffect } from 'react';
import './MoreMenu.css';

const MoreMenu = ({ onEdit, onDelete }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleEdit = () => {
    onEdit();
    setIsOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsOpen(false);
  };

  return (
    <div className="more-menu" ref={menuRef}>
      <button 
        className="more-menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        title="More options"
      >
        ⋯
      </button>
      
      {isOpen && (
        <div className="more-menu-dropdown">
          <button 
            className="more-menu-item edit-item"
            onClick={handleEdit}
          >
            Edit
          </button>
          <button 
            className="more-menu-item delete-item"
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default MoreMenu;
